import { useTranslation } from "@/packages/utils";
import { useDatePickerContext } from "./DatePickerContext";
import type { DatePickerActionsProps } from "./types";
import { Button } from "../primitives";

export function DatePickerActions({
  confirmLabel,
  cancelLabel,
}: DatePickerActionsProps) {
  const { t } = useTranslation(["common"]);
  const resolvedConfirmLabel = confirmLabel ?? t("datePicker.apply");
  const resolvedCancelLabel = cancelLabel ?? t("buttons.cancel");
  const { confirm, cancel, clear, pendingDate } = useDatePickerContext();

  return (
    <div className="flex items-center justify-between border-t border-border px-3 py-2">
      <div>
        {pendingDate && (
          <Button
            variant="ghost"
            size="sm"
            onClick={clear}
            className="text-xs px-0"
          >
            {t("datePicker.clear")}
          </Button>
        )}
      </div>

      <div className="flex items-center gap-2">
        <Button variant="ghost" size="sm" onClick={cancel} className="text-xs">
          {resolvedCancelLabel}
        </Button>
        <Button
          variant="primary"
          size="sm"
          onClick={confirm}
          className="text-xs"
        >
          {resolvedConfirmLabel}
        </Button>
      </div>
    </div>
  );
}
